import { render } from "./HumanResource.vue?vue&type=template&id=837b4874"
import script from "./HumanResource.vue?vue&type=script&lang=js"
export * from "./HumanResource.vue?vue&type=script&lang=js"

import "./HumanResource.vue?vue&type=style&index=0&id=837b4874&lang=css"

import exportComponent from "C:\\ExactFloMarketingTool\\exactfloMarketingTool\\frontend\\marketingtool\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__